import { Link } from 'react-router-dom';
import { FeatureGate } from '@/components/FeatureGate';

export function Footer() {
  return (
    <footer
      className="text-center py-4 border-t border-sand mb-20 md:mb-0"
      data-testid="site-footer"
    >
      <p className="font-serif italic text-[11px] text-warm-gray">
        The Quiet Between Pitches <span className="mx-1">&middot;</span> &copy;{' '}
        {new Date().getFullYear()} The Linescore
      </p>
      <FeatureGate flag="show_scoring_101">
        <p className="mt-1">
          <Link
            to="/scoring-101"
            className="font-sans text-[11px] text-warm-gray hover:text-ink uppercase tracking-[1px]"
            data-testid="footer-scoring-101-link"
          >
            Scoring 101
          </Link>
        </p>
      </FeatureGate>
    </footer>
  );
}
